/* Convenient Cash — theme JS */
(function () {
  'use strict';

  // ---- Mobile menu toggle ------------------------------------------------
  const btn = document.getElementById('menuToggle');
  const menu = document.getElementById('mobileMenu');
  const iconOpen = document.getElementById('menuIconOpen');
  const iconClose = document.getElementById('menuIconClose');

  if (btn && menu) {
    const setOpen = (open) => {
      menu.classList.toggle('hidden', !open);
      if (iconOpen) iconOpen.classList.toggle('hidden', open);
      if (iconClose) iconClose.classList.toggle('hidden', !open);
      btn.setAttribute('aria-expanded', String(open));
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.style.overflow = open ? 'hidden' : '';
    };
    btn.addEventListener('click', () => setOpen(menu.classList.contains('hidden')));
    menu.querySelectorAll('a').forEach((a) =>
      a.addEventListener('click', () => setOpen(false))
    );
    // Close on ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !menu.classList.contains('hidden')) setOpen(false);
    });
  }

  // ---- Cart count refresh after add-to-cart ------------------------------
  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.toggle('hidden', cart.item_count === 0);
      });
    } catch (e) { /* ignore */ }
  }
  refreshCartCount();

  // Intercept add-to-cart forms to use AJAX with the Shopify Cart API
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.getAttribute('action') !== '/cart/add' && !form.matches('form[action*="/cart/add"]')) return;

    e.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    const originalLabel = submit ? submit.innerHTML : '';
    if (submit) {
      submit.disabled = true;
      submit.innerHTML = 'Adding…';
    }
    try {
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!res.ok) throw new Error('Add to cart failed');
      await refreshCartCount();
      if (submit) submit.innerHTML = 'Added ✓';
      setTimeout(() => {
        if (submit) { submit.disabled = false; submit.innerHTML = originalLabel; }
      }, 1400);
    } catch (err) {
      if (submit) { submit.disabled = false; submit.innerHTML = originalLabel; }
      window.location.href = '/cart';
    }
  });
})();
